/**
 * 上传的印章 / 签名图先在浏览器里缩一遍再存进模板。
 *
 * 模板是整包存的（本地 + 云端），一枚 2000×2000 的章 base64 后两三 MB，
 * 两三枚就逼近 8MB 的同步上限；更要命的是关标签页时的兜底推送走 keepalive，
 * 那条通道只能带 64KB —— 章一大，最后一次改动就永远上不了云。
 * 印章打印 40mm，900px 足够清晰。保留透明通道。
 */
export async function compressImageFile(file: File, maxPx = 900): Promise<string> {
  const raw = await new Promise<string>((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result));
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error('decode'));
      i.src = raw;
    });
    const scale = Math.min(1, maxPx / Math.max(img.width, img.height));
    if (scale >= 1 && raw.length < 300 * 1024) return raw; // 本来就小，别重编码
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.width * scale));
    canvas.height = Math.max(1, Math.round(img.height * scale));
    const ctx = canvas.getContext('2d');
    if (!ctx) return raw;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const out = canvas.toDataURL('image/png');
    return out.length < raw.length ? out : raw;
  } catch {
    return raw;
  }
}
